import React, { createContext, useContext, useState, ReactNode } from "react";

type BusinessType = "All" | "Restaurant" | "Services" | "Retail";

interface FilterContextType {
  businessType: BusinessType;
  setBusinessType: (type: BusinessType) => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};

interface FilterProviderProps {
  children: ReactNode;
}

export const FilterProvider: React.FC<FilterProviderProps> = ({ children }) => {
  const [businessType, setBusinessType] = useState<BusinessType>("All");

  return (
    <FilterContext.Provider value={{ businessType, setBusinessType }}>
      {children}
    </FilterContext.Provider>
  );
};
